"use strict";

angular.module('app.controllers.statistic', []).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('statistic', {
        parent: 'site',
        url: '/statistic',
        templateUrl: 'views/statistic.html',
        controller: 'StatisticCtrl',
        breadcrumb: {
            initialState: true,
            name: 'NAV_Statistic'
        }
    });
}]).controller("StatisticCtrl", ['$rootScope', '$scope', '$filter', 'f_Info', 'API', '__Datapoint', 'Devices', 'statisticModal', 'ENUM', 'viewMenuBarService', '__MenuEntry','f_Devices',
    function ($rootScope, $scope, $filter, f_Info, API, __Datapoint, Devices, statisticModal, ENUM, viewMenuBarService, __MenuEntry,f_Devices) {

        var favoriteObject = {
            favoriteType: 'MenuEntry',
            favoriteObject: __MenuEntry.$buildRaw({
                "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                "MenuEntryId": '00000000-0000-0000-0000-000000000004',
                "DeviceId": '00000000-0000-0000-0000-000000000000',
                'DisplayName': 'Statistik',
                'ImageName': 'statistik',
                'CustomActionName': 'Statistics',
                'CustomActionDatas': {
                    '$type': "System.Collections.Generic.List`1[[System.String, mscorlib]], mscorlib",
                    '$values': ['00000000-0000-0000-0000-000000000004']
                }
            })
        };


        $scope.rootScope = $rootScope;
        $scope.Devices = Devices;
        /*$scope.$on('InitActualView', function () {
         $scope.init();
         })
         $scope.$on('Devices', function () {
         $scope.init();
         });*/
        $scope.getClass = function (DP,Dev,property) {
            var p ;
            if(!property){
                p = 'LoggingEnabledByUserlevel';
            }else{
                p = property;
            }
            if (!DP) {
                if (Dev.$UI[p]) {
                    return 'green';
                }
            } else {
                if (DP && DP[p]) {
                    return 'green';
                }else{

                }
            }

            return '';
        };

        $scope.init = function () {
            viewMenuBarService.setButtons({});
            viewMenuBarService.setFavorite(favoriteObject);
            $scope.noDatapointsToLog = true;
            $scope.DeviceTypes = ENUM.getDeviceTypesByFilter('1AsKey');

            var _API = new API();
            _API.Device.GetAllLogSettings()
                .$promise.then(function (data) {
                if (data) {

                    var DPValues = [];
                    var DPLogValues = [];
                    $scope.Datapoints = __Datapoint.$collection();
                    var logDevices = $filter('filter')(
                        data,
                        function (o) {
                            return (o && o.DatapointsToLog && o.DatapointsToLog.length > 0);
                        }
                    );
                    if (logDevices.length > 0) {
                        $scope.noDatapointsToLog = false;
                    }
                    var ld = [];
                    for (var i = 0; i < logDevices.length; i++) {
                        var d = f_Devices.getById( logDevices[i].DeviceId );

                        if (logDevices[i].DatapointsToLog !== undefined) {
                            for (var j = 0; j < logDevices[i].DatapointsToLog.length; j++) {

                                DPValues.push(
                                    logDevices[i].DatapointsToLog[j].DatapointValue);
                                DPLogValues.push(
                                    logDevices[i].DatapointsToLog[j]);
                            }
                        }
                        var dps;

                        if (logDevices[i] && logDevices[i].DatapointsToLog !== undefined) {
                            dps = logDevices[i].DatapointsToLog;
                        } else {
                            dps = [];
                        }

                        ld.push({
                                'Device': d,
                                'DeviceType': d.DeviceType,
                                'DatapointsToLog': dps

                            }
                        );

                    }

                    $scope.LogDevices = $filter('orderBy')(ld,'-DeviceType',true);

                    //var temp = '';
                    //$scope.LogDevices.forEach(function(logDevice) {
                    //    logDevice.DatapointsToLog.forEach(function(dp) {
                    //        temp+= dp.DatapointValue.DatapointConfigId + ', ';
                    //    });
                    //    console.log('DT: ' + logDevice.DeviceType + ', Cids: ' + temp);
                    //    temp = '';
                    //});

                    _API.Datapoint
                        .GetConfigsByDatapointValues({'DatapointValues': DPValues})
                        .$promise
                        .then(function (DatapointConfigs) {
                            $scope.LogDevices.forEach(function(device) {
                                device.DatapointsToLog.forEach(function(dpToLog) {
                                    for (var k = 0; k < DatapointConfigs.length; k++) {
                                        if (DatapointConfigs[k].DatapointConfigId === dpToLog.DatapointValue.DatapointConfigId
                                        && DatapointConfigs[k].DeviceType === device.Device.DeviceType
                                        && DatapointConfigs[k].ConfigVersion === device.Device.ConfigVersion) {
                                            dpToLog.DatapointConfig = DatapointConfigs[k];
                                            // Fix for wrong API naming
                                            dpToLog.StatisticEnabled = dpToLog.StatisticLoggingEnabled;

                                            var dataP = __Datapoint.$buildRaw(dpToLog);
                                            dataP.$dispatch('resolve-flags').setReadFlags();


                                            //console.log('Cid: ' + dataP.DatapointConfig.DatapointConfigId
                                            // + ', DT: ' + dataP.DatapointConfig.DeviceType
                                            // + ', DV: ' + dataP.DatapointConfig.ConfigVersion
                                            // + ', DN: ' + dataP.DatapointConfig.DisplayName
                                            // + ', WKN: ' + dataP.DatapointConfig.WellKnownName);

                                            $scope.Datapoints.$add(
                                                dataP
                                            );
                                            break;
                                        }
                                    }
                                });
                            });
                        });


                   // $scope.Datapoints.$dispatch('refresh-values');
                    /*
                     _API.Datapoint.ReadValues({'DatapointValues': DPValues}).$promise.
                     then(function(DatapointValues){



                     for (var j = 0; j < DPValues.length; j++) {
                     for (var i = ( DatapointValues.length - 1); i >= 0; i--) {

                     if (DPValues[j].DatapointValue.DatapointConfigId == DatapointValues[i].DatapointConfigId
                     && DPValues[j].DatapointValue.DeviceId == DatapointValues[i].DeviceId
                     ) {

                     DPValues[j].DatapointValue.Value = DatapointValues[i].Value;
                     dao.prepareDatapoint(DPValues[j]);
                     DatapointValues.splice(i, 1);
                     //console.log(updateConfigs[j]);
                     break;
                     }
                     }
                     }

                     })*/
                }
            });

        };

        $scope.$on("FavoritesUpdate", function () {
            $rootScope.$broadcast('FavoriteHeadChange', {object: $scope.favoriteObject});
        });

        $scope.isDifferent = function (a, b) {
            return (angular.isUndefined(a) || angular.isUndefined(b) || a !== b);
        };

        $scope.addToStatistic = function (dp, Device) {
            if ($scope.DatapointsForStatistic === undefined) {
                $scope.DatapointsForStatistic = [];
            }

            var found = false;

            for (var i = $scope.DatapointsForStatistic.length - 1; i >= 0; i--) {
                if ($scope.DatapointsForStatistic[i].DatapointConfigId === dp.DatapointValue.DatapointConfigId && $scope.DatapointsForStatistic[i].DeviceId === dp.DatapointValue.DeviceId) {
                    $scope.DatapointsForStatistic.splice(i, 1);
                    found = true;
                    break;
                }
            }
            if (found === true) {
                dp.Enabled = false;
            } else {
                if ($scope.DatapointsForStatistic.length === 3) {
                    f_Info.addInfo({
                        "Type": 1,
                        "TitleTranslated": 'WIDGET_Statistic_NoMoreThanThreeTitle',
                        "DisplayTextTranslated": 'WIDGET_Statistic_NoMoreThanThreeText'
                    });
                } else {
                    dp.Enabled = true;
                    $scope.DatapointsForStatistic.push({
                            "Device": Device,
                            'DeviceId': dp.DatapointValue.DeviceId,
                            'DatapointConfigId': dp.DatapointConfig.DatapointConfigId,
                            "DisplayName": dp.DatapointConfig.DisplayName,
                            "Config": dp.DatapointConfig,
                            "DPReference": dp
                        }
                    );
                }
            }
        };

        $scope.showStatistic = function () {
            if ($scope.DatapointsForStatistic === undefined || $scope.DatapointsForStatistic.length === 0) {
                $scope.DatapointsForStatistic = [];
            }

            $scope.statisticObject = {
                "FromUTC": moment().startOf('day').utc(),
                "ToUTC": moment().endOf('day').add({'seconds': 1}).utc(),
                "Datapoints": angular.copy($scope.DatapointsForStatistic),
                "Period": 1,
                "PeriodType": 0,
                "initByController": true,
                "initPeriodType": 0
            };

            statisticModal($scope.statisticObject);
        };

        $scope.init();
        $scope.$on('UserlevelChange', function () {
            $scope.init();
        });


    }
]);
